import "./Canvas.css";

const Canvas = ({ Output, dimensions, variables, recordingRef }) => (
  <div className="Canvas">
    <Output
      dimensions={dimensions}
      variables={variables}
      recordingRef={recordingRef}
    />
  </div>
);

export default Canvas;
